import { jsx as _jsx } from "react/jsx-runtime";
// JSON syntax highlighting component
export var JsonViewer = function (_a) {
    var data = _a.data;
    var jsonString = JSON.stringify(data, null, 2);
    var syntaxHighlight = function (json) {
        json = json
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"\r\n])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            var cls = "text-gray-40";
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = "text-black"; // property names
                }
                else {
                    cls = "text-blue-40"; // string values
                }
            }
            else if (/true|false/.test(match)) {
                cls = "text-purple-40"; // booleans
            }
            else if (/null/.test(match)) {
                cls = "text-red-40"; // null
            }
            else {
                cls = "text-orange-40"; // numbers
            }
            return "<span class=\"".concat(cls, "\">").concat(match, "</span>");
        });
    };
    return (_jsx("pre", { className: "whitespace-pre-wrap break-words", dangerouslySetInnerHTML: { __html: syntaxHighlight(jsonString) } }));
};
